import { Box } from '@mui/material';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { NumberBox } from 'components/NumberBox';
import React from 'react';
import { TransactionsDetailData } from 'services/centralServerService/data-contracts';
import moment from 'moment';
import { observer } from 'mobx-react';
import { useStores } from 'stores/storeInitializer';
import { formatCurrencyAmount, getSessionCurrency } from 'utils/currency';

export const SessionNumberBoxes: React.FC<{
    session: TransactionsDetailData | null | undefined;
}> = observer(({ session }) => {
    const sessionStopData = session?.stop;
    const { store } = useStores();
    const currency = getSessionCurrency(session);
    const totalCost =
        session?.stop?.roundedPriceInclVat ?? session?.stop?.roundedPrice ?? 0;
    return sessionStopData ? (
        <React.Fragment>
            <Box
                pb={1}
                display={'flex'}
                width={'100%'}
                height={'18%'}
                justifyContent={'space-around'}
            >
                <NumberBox
                    value={(
                        (session.stop.totalConsumptionWh || 0) / 1000
                    ).toFixed(2)}
                    label={store.L(LocalizationKeys.ConsumptionWithUnits)}
                    color={'info'}
                />
                <NumberBox
                    value={formatCurrencyAmount(
                        totalCost,
                        currency,
                        (store as any).language || 'en',
                    )}
                    label={store.L(LocalizationKeys.CostWithCurrency, currency)}
                    color={'success'}
                />
            </Box>
            <Box
                pt={1}
                pb={2}
                display={'flex'}
                width={'100%'}
                justifyContent={'space-around'}
                height={'18%'}
            >
                <NumberBox
                    value={`${moment
                        .duration(session.stop.totalDurationSecs, 'seconds')
                        .asMinutes()
                        .toFixed(0)}`}
                    color={'warning'}
                    label={store.L(LocalizationKeys.DurationWithUnits)}
                />
                <NumberBox
                    value={`${moment
                        .duration(session.stop.inactivityStatus, 'seconds')
                        .asMinutes()
                        .toFixed(0)}`}
                    color={'error'}
                    label={store.L(LocalizationKeys.InactivityWithUnits)}
                />
            </Box>
        </React.Fragment>
    ) : null;
});
